export default {
  siteId: "9",
  siteName: "ca",
  site: "ca",
  lang: "English",
  langCode: "en-GB",
  activityName: "",
  productList: "product list",
  POST: "POST",
  Score: "Score",
  Title: "Title",
  Review: "Review",
  Media: "Media",
  MediaType: "Supported file types include JPEG, JPG, PNG or MP4.",
  MediaReward: "Share pictures or videos to unlock special rewards.",
  RewardQa: "Complete all the below questions for additional rewards.",
  RewardsToast:
    "Thank You for The Awesome Review! Your reward has been successfully credited to your account!",
  MoreQa: "Click to fill in more questions.",
  rateLevel1: "Very dissatisfied",
  rateLevel2: "Somewhat dissatisfied",
  rateLevel3: "Neither satisfied nor dissatisfied",
  rateLevel4: "Somewhat satisfied",
  rateLevel5: "Very satisfied",
  "LEAVE A REVIEW": "Please leave a review",
  "Please enter a star rating for this review":
    "Please enter a star rating for this review",
  "Review’s title can’t be empty": "Review’s title & body can’t be empty",
  "Review’s body can’t be empty": "Review’s title & body can’t be empty",
  "Please upload a media less than 10 megabytes":
    "Please upload a media less than 10 megabytes",
  "Please upload a media less than 20 megabytes":
    "Please upload a media less than 20 megabytes",
  "THANK YOU FOR YOUR COMMENTS": "THANK YOU FOR YOUR COMMENTS",
  "We love seeing reviews":
    "We love seeing reviews - thanks for posting yours! Feel free to share so others can see it, too.",
  "fill out":
    "Please fill out the form below and submit your site review, it would be very much appreciated.",
  "SUBMIT YOUR REVIEW": "SUBMIT YOUR REVIEW",
  shopping: "https://ca.cupshe.com",
  mailto: "customercare",
  pageTitle: "Customer Review",
  "VIEW COMMENTS": "VIEW COMMENTS",
  "GO SHOPPING": "GO SHOPPING",
  mailText: `To make sure you receive our email updates, please add <a style="color:#333;text-decoration: underline;" class="c-muli-light" href="mailto:{mailto}{domain}">{mailto}{domain}</a> to your address book.`,
  email: "email",
  "contact us": "contact us",
  contactUrl: "https://ca.cupshe.com/pages/contact-us",
  chat: "chat",
  next: "next",
  copyright: "Copyright © {year} Cupshe {sitename}, All rights reserved.",
  subscribe1:
    "You've Successfully Unsubscribed to Cupshe CA Marketing Messages",
  subscribe2: "Didn’t mean to unsubscribe?",
  subscribe3: "RESUBSCRIBE",
  subscribe4:
    "You've Successfully Been Resubscribed to Cupshe CA's Marketing Messages.",
  "You're already on the list!": "You're already on the list!",
  "Oops, there was a hiccup!Please try again.":
    "Oops, there was a hiccup!Please try again.",
  trustsubscribe:
    "Thank you for your trust, we will provide you with better services and more affordable products.",
  mailContact:
    'Please contact <a href="https://ca.cupshe.com/pages/contact-us" class="contact_link">customer service</a> for assistance.',
  policyText:
    "*Please note: After you unsubscribe, you may receive emails containing contractual information regarding future online purchases (order confirmations, shipping notifications, refund notifications, etc.).",
};
